import React from 'react';
import { useAnalytics } from '../../../../../utils/analytics-provider/analytics-provider';

import {
  StyledContainer,
  StyledButton,
  StyledChatIconContainer,
  StyledChatIcon,
  StyledTextBlock,
  StyledText
} from './styles';

const Chat = () => {
  const { trackEvent } = useAnalytics();

  return (
    <StyledContainer>
      <StyledButton
        href="#"
        onClick={(ev) => {
          ev.preventDefault();
          trackEvent('content_engagement_v2', { engagement_type: 'chat_with_us_link' });
          window.CarvanaChatUi.show();
        }}
      >
        <StyledChatIconContainer>
          <StyledChatIcon />
        </StyledChatIconContainer>
        <StyledTextBlock>
          <StyledText>Chat with us</StyledText>
        </StyledTextBlock>
      </StyledButton>
    </StyledContainer>
  );
};

export default Chat;
